// extracted by mini-css-extract-plugin
export default {"tabHeader":"styles_tab-header__RsGtT","tabHeaderItem":"styles_tab-header-item__Ga1IF","tabHeaderItemActive":"styles_tab-header-item-active__KTnwS"};